/**
 * StatusBadge Atom Component
 * Displays status with appropriate styling
 */

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { ReservationStatus } from '@/types'

interface StatusBadgeProps {
	status: ReservationStatus | 'available' | 'unavailable'
	className?: string
}

const statusConfig = {
	pending: {
		label: 'Pendiente',
		variant: 'default' as const,
		className: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
	},
	confirmed: {
		label: 'Confirmado',
		variant: 'default' as const,
		className: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
	},
	active: {
		label: 'Activo',
		variant: 'default' as const,
		className: 'bg-green-100 text-green-800 hover:bg-green-100',
	},
	completed: {
		label: 'Completado',
		variant: 'default' as const,
		className: 'bg-gray-100 text-gray-800 hover:bg-gray-100',
	},
	cancelled: {
		label: 'Cancelado',
		variant: 'destructive' as const,
		className: '',
	},
	available: {
		label: 'Disponible',
		variant: 'default' as const,
		className: 'bg-[#CDFF00] text-[#09194D] hover:bg-[#CDFF00]',
	},
	unavailable: {
		label: 'No Disponible',
		variant: 'default' as const,
		className: 'bg-gray-200 text-gray-600 hover:bg-gray-200',
	},
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
	const config = statusConfig[status]

	return (
		<Badge
			variant={config.variant}
			className={cn(config.className, className)}
		>
			{config.label}
		</Badge>
	)
}
